import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const LibraryRules = () => {
     useEffect(() => {
        document.title = 'Library Rules -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
     <li>  Academics</li> 
     <li>Library Rules</li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Library Rules </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <ul className="list">
        <li>Books are issued for two weeks only. If a child fails to return the book on time fine will be charged for the same. </li>
       <li>The readers shall not sub-lend the books issued by the library. </li>
       <li>Books marked, disfigured, damaged or misplaced will have to be replaced or paid for by the borrower. </li>
       <li>Children should maintain a diary for library notes that will help them to improve their vocabulary & language skills. </li>
       <li>Children should follow all library rules and maintain silence in the library.</li>
       </ul>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default LibraryRules
